<template>
  <div
    class="w-full py-6 md:py-0 md:h-[160px] flex flex-col justify-center items-center relative overflow-hidden"
  >
    <h1
      class="w-[70vw] md:max-w-screen-lg sm:px-6 text-center text-xl sm:text-3xl md:text-4xl capitalize text-shadow-title break-words z-0 font-platform"
    >
      {{ title }}
    </h1>

    <div class="w-full hidden md:flex justify-center relative z-10 px-2">
      <div
        class="px-2 py-1 rounded-full text-sm flex items-center bg-white text-gray-600 flex-wrap justify-center"
      >
        <NuxtLink class="capitalize mr-1" to="/">
          <span class="sr-only">Naar home</span>
          <FontAwesome icon="home" />
        </NuxtLink>
        <span
          class="whitespace-nowrap"
          v-for="(route, index) in routes"
          :key="index"
        >
          <span
            ><FontAwesome icon="chevron-left" class="mx-1 text-gray-400" />
            <NuxtLink
              class="capitalize"
              :class="{
                underline: routes.length < index + 1,
                'text-gray-400': routes.length === index + 1,
              }"
              :to="route.path"
              @click.prevent="() => onClickRoute(route.path)"
              ><span class="sr-only">Naar </span
              >{{ route.name.replace(/-/g, ' ') }}</NuxtLink
            >
          </span>
        </span>
      </div>
    </div>

    <div
      class="absolute h-full max-w-screen-md lg:max-w-screen-lg xl:max-w-screen-lg w-full mx-auto inset-0 py-[2px] md:px-24"
    >
      <div class="relative w-full h-full">
        <!-- Mask for mobile -->
        <div
          class="md:hidden absolute top-0 w-[15vw] h-full"
          :class="[`${color}`]"
          :style="{
            maskPosition: 'bottom right',
            maskSize: `auto calc(100% / 2)`,
            maskImage: `url(/pattern/${pattern}.svg)`,
          }"
        ></div>

        <div
          class="md:hidden absolute top-0 right-0 w-[15vw] h-full"
          :class="[`${color}`]"
          :style="{
            maskPosition: 'bottom left',
            maskSize: `auto calc(100% / 2)`,
            maskImage: `url(/pattern/${pattern}.svg)`,
          }"
        ></div>

        <!-- Both mask sides for desktop -->
        <div
          class="hidden md:flex flex-col gap-2 absolute top-0 right-full w-[50vw] h-full"
        >
          <div
            v-for="i in Number(repeat)"
            :key="i"
            class="w-full"
            :style="{
              height: `calc(100% / ${repeat})`,
              paddingRight: i % 2 == 0 ? '0px' : '0px',
            }"
          >
            <div
              class="w-full h-full"
              :class="[`${color}`]"
              :style="{
                maskPosition: 'center right',
                maskSize: `auto 100%`,
                maskImage: `url(/pattern/${pattern}.svg)`,
                maskRepeat: 'repeat-x',
              }"
            />
          </div>
        </div>

        <div
          class="hidden md:flex flex-col gap-2 absolute top-0 left-full w-[50vw] h-full"
        >
          <div
            v-for="i in Number(repeat)"
            :key="i"
            class="w-full"
            :style="{
              height: `calc(100% / ${repeat})`,
              paddingLeft: i % 2 == 0 ? '0px' : '0px',
            }"
          >
            <div
              class="w-full h-full"
              :class="[`${color}`]"
              :style="{
                maskPosition: 'center right',
                maskSize: `auto 100%`,
                maskImage: `url(/pattern/${pattern}.svg)`,
                maskRepeat: 'repeat-x',
                transform: 'scaleX(-1)',
              }"
            />
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="w-full flex md:hidden justify-center relative z-10 px-2">
    <div
      class="px-2 py-1 rounded-full text-xs sm:text-sm flex items-center bg-white text-gray-600 flex-wrap sm:justify-center"
    >
      <NuxtLink class="capitalize mr-1" to="/">
        <span class="sr-only">Naar home</span>
        <FontAwesome icon="home" />
      </NuxtLink>
      <span
        class="whitespace-nowrap"
        v-for="(route, index) in routes"
        :key="index"
        @click.prevent="() => onClickRoute(route.path)"
      >
        <span
          ><FontAwesome icon="chevron-left" class="mx-1 text-gray-400" />
          <NuxtLink
            class="capitalize"
            :class="{
              underline: routes.length < index + 1,
              'text-gray-400': routes.length === index + 1,
            }"
            :to="route.path"
            ><span class="sr-only">Naar </span
            ><span
              v-if="
                routes.length === 1 ||
                (routes.length > 1 && index + 1 !== routes.length)
              "
              >{{ route.name.replace(/-/g, ' ') }}</span
            ><span v-else>...</span></NuxtLink
          >
        </span>
      </span>
    </div>
  </div>
</template>

<script setup>
const route = useRoute();

const props = defineProps({
  title: {
    type: String,
    default: '',
  },
  color: {
    type: String,
    default: 'bg-los-pink-base',
  },
  pattern: {
    type: String,
    default: 'kruissteek',
  },
  repeat: {
    type: String,
    default: '3',
  },
});

const routes = computed(() => {
  let path = route.path.split('/');
  path = path.slice(1, path.length);
  return path
    .map((slug, index) => {
      return {
        name: slug,
        path: '/' + path.slice(0, index + 1).join('/'),
      };
    })
    .filter((part) => part.name.length);
});

async function onClickRoute(path) {
  await navigateTo(
    {
      path,
    },
    {
      external: path.includes('/machines'),
    }
  );
}
</script>

<style lang="scss" scoped></style>
